import * as React from "react";
const SvgButtonInstructionsWhite = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	id: "Information-Circle--Streamline-Streamline-3.0",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Information Circle Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("path", {
	stroke: "#fff",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M14.25 16.5h-0.75A1.5 1.5 0 0 1 12 15v-3.75a0.75 0.75 0 0 0 -0.75 -0.75h-0.75",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "#fff",
	d: "M11.625 7.5a0.375 0.375 0 0 1 0 -0.75",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "#fff",
	d: "M11.625 7.5a0.375 0.375 0 0 0 0 -0.75",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "#fff",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M12 23.25c6.213 0 11.25 -5.037 11.25 -11.25S18.213 0.75 12 0.75 0.75 5.787 0.75 12 5.787 23.25 12 23.25Z",
	strokeWidth: 1.5
}));
export { SvgButtonInstructionsWhite as ReactComponent };
